<script setup>
defineProps({
  newsItem: {
    type: Object,
    required: true,
  },
  whiteBackground: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="main-news-block-item">
    <div class="main-news-block-item__title">
      {{ newsItem.title }}
      <div
        class="main-news-block-item__title--shadow"
        :class="{
          'main-news-block-item__title--white-shadow': whiteBackground,
        }"
      ></div>
    </div>
    <PostCardDate :date="newsItem.publishedAt" />
  </div>
</template>

<style lang="postcss" scoped>
.main-news-block-item {
  display: flex;
  flex-direction: column;
  max-width: 240px;
  height: 164px;

  &__title {
    position: relative;
    height: 100%;
    margin-bottom: auto;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    overflow: hidden;
    transition: var(--default-transition) color;

    &--shadow {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 54px;
      background: linear-gradient(
        180deg,
        rgba(255, 237, 242, 0%) 0%,
        #ffedf3 90%
      );
    }

    &--white-shadow {
      background: linear-gradient(180deg, transparent 26.56%, #fffcfe 100%);
    }
  }

  &:hover {
    .main-news-block-item__title {
      color: var(--accent-color);
    }
  }

  @media (--small-vp) {
    gap: 8px;
    max-width: none;
    height: auto;
    min-height: auto;
    overflow: hidden;

    &__title {
      margin-bottom: auto;
      font-size: 13px;
      line-height: 18px;

      &--shadow {
        display: none;
      }
    }
  }
}
</style>
